import { render, staticRenderFns } from "./DailyLimitOfCredits.vue?vue&type=template&id=49243d29&"
import script from "./DailyLimitOfCredits.vue?vue&type=script&lang=js&"
export * from "./DailyLimitOfCredits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports